<template>
  <div>
    <transition :name="(transitionActive) ? 'v-fade' : ''" mode="out-in">
      <component
          :is="currentTabComponent"
          :id-prefix="idPrefix"
          @go:create="currentTabComponent = 'authFormCreate'"
          @go:auth="currentTabComponent = 'authFormAuth'"
          @go:auth-new="goAuthNew"
          @go:recovery="goRecovery"
          @close="$emit('close')"
          :start-email="recoveryStartMail"
          :page-params="pageParams"
          :new-pass-start="newPassStartMail"
      />
    </transition>
  </div>
</template>

<script>

import authFormAuth from "./auth-form-auth.vue";
import authFormRecovery from "./auth-form-recovery.vue";
import authFormCreate from "./auth-form-create.vue";
import authFormNew from "./auth-form-new.vue";

export default {
  name: "auth-form",
  components: {
    authFormAuth,
    authFormRecovery,
    authFormCreate,
    authFormNew
  },
  props: {
    idPrefix: String,
    pageParams: Object,
    startTab: String,
    transitionActive: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close'],
  data() {
    return {
      currentTabComponent: 'authFormAuth',
      recoveryStartMail: '',
      newPassStartMail: ''
    }
  },
  methods: {
    goRecovery(data) {
      if (data) {
        this.recoveryStartMail = data;
      } else {
        this.recoveryStartMail = '';
      }
      this.currentTabComponent = 'authFormRecovery'
    },
    goAuthNew(data) {
      if (data) {
        this.newPassStartMail = data;
      } else {
        this.newPassStartMail = '';
      }
      this.currentTabComponent = 'authFormAuth'
    },
  },
  created() {
    if (this.pageParams.startInNew) {
      this.currentTabComponent = 'authFormNew'
    } else if (this.startTab) {
      this.currentTabComponent = this.startTab;
    }
  }
}
</script>